export const RoutesPrefix = {
  PROJECT: '/project',
  ORGANIZATION: '/organization',
};
const Routes = {
  // Portal routes
  HOME: '/',
  LOGIN: '/login',
  PROJECT: '/project',
  PROJECT_DETAIL: `${RoutesPrefix.PROJECT}/:projectID`,
  PROJECT_3D: '/project-3D',
  MAP_LAYERS: '/map-layers',
  DIRECTORIES: '/directories',
  SETTING: '/setting',
  PROFILE: '/profile',
  CHANGE_PASSWORD: '/profile/change-password',
  CHANGE_PASSWORD_ALIAS: '/change-password',
  UPLOAD_TASK: '/upload-task',
  TRANSFER_TO_MOBILE: '/transfer',
  FREE_PHOTOS: '/free-photos',
  ORGANIZATION: '/organization',
  ORGANIZATION_DETAIL: `${RoutesPrefix.ORGANIZATION}/:organizationID`,
  ORGANIZATION_REGISTRATION: `${RoutesPrefix.ORGANIZATION}/:organizationID/registration`,
  ORGANIZATION_UPDATE: `${RoutesPrefix.ORGANIZATION}/:id/edit`,

  // Collect Form routes (Project forms)
  COLLECT_FORMS: '/collect-form',

  // Collect Form Templates (Form schemas / templates)
  COLLECT_FORM_TEMPLATES: '/collect-form-template',
  COLLECT_FORM_TEMPLATE_DESIGN: '/collect-form-template/design',
  COLLECT_FORM_TEMPLATE_DESIGN_EDIT: '/collect-form-template/design/:templateId',

  // Backwards compatibility aliases
  COLLECT_FORM_DESIGN: '/collect-form/design',
  COLLECT_FORM_DESIGN_EDIT: '/collect-form/design/:templateId',
  FORM_BUILDER: '/form-builder',
  FORM_BUILDER_EDIT: '/form-builder/:templateId',

  // Map Data & Action Gateway routes
  ACTION_GATEWAY: '/action',
  MAP_DATA_REDIRECT: '/map-data/:mapDataId',

  NOT_FOUND: '*',
};

export default Routes;
